import React from 'react';
import { Cloud, Sun, CloudRain } from 'lucide-react';
import DashboardCard from './DashboardCard';

const WeatherWidget = () => {
  // Mock weather data - in real app this would come from weather API
  const weather = {
    temperature: 22,
    condition: 'sunny',
    location: 'Stockholm',
    uvIndex: 6,
    windSpeed: 12
  };

  const getWeatherIcon = (condition: string) => {
    switch (condition) {
      case 'sunny': return <Sun className="h-8 w-8 text-sunset-yellow" />;
      case 'cloudy': return <Cloud className="h-8 w-8 text-gray-400" />;
      case 'rainy': return <CloudRain className="h-8 w-8 text-blue-400" />;
      default: return <Sun className="h-8 w-8 text-sunset-yellow" />;
    }
  };

  return (
    <DashboardCard
      title="Current Weather"
      description={`Conditions in ${weather.location}`}
      variant="success"
      isPlaceholder
      placeholderText="API Integration Pending"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {getWeatherIcon(weather.condition)}
          <div>
            <div className="text-2xl font-bold">{weather.temperature}°C</div>
            <div className="text-sm text-muted-foreground capitalize">
              {weather.condition}
            </div>
          </div>
        </div>
        
        <div className="text-right space-y-1">
          <div className="text-sm">
            <span className="text-muted-foreground">UV:</span> {weather.uvIndex}
          </div>
          <div className="text-sm">
            <span className="text-muted-foreground">Wind:</span> {weather.windSpeed} km/h
          </div>
        </div>
      </div>
      
      <div className="mt-4 p-3 bg-emerald-50/50 rounded-lg border border-emerald-200/30">
        <div className="text-sm font-medium text-emerald-700">
          Great terrace weather today! ☀️
        </div>
        <div className="text-xs text-emerald-600 mt-1">
          Perfect conditions for outdoor dining
        </div>
      </div>
    </DashboardCard>
  );
};

export default WeatherWidget;